<template>
    
    <div>

        <!-- expansion panel titles -->
        <!-- <v-expansion-panels disabled flat style="background-color:transparent !important;">
          <v-expansion-panel style="background-color:transparent !important;" class="mb-2">
            <v-expansion-panel-header style="background-color:transparent !important;">
              <v-card flat color="transparent">
                <v-layout class="synThickFont white--text synLargeFont" row wrap align-center>
                
                  <v-flex  md1>
                      
                  </v-flex>
                  
                  <v-flex fill-height  md4 class="px-3 mySongsTitles" style="background-color:red;">
                    Title
                  </v-flex>
                  
                  <v-flex  md2 class="mySongsTitles" style="background-color:orange;">
                    Genre
                  </v-flex>
                  
                  <v-flex  md2 class="mySongsTitles text-center" style="background-color:red;">
                    Submissions
                  </v-flex>
                  
                  <v-flex md2 class="pr-5 mySongsTitles" style="background-color:green;">             
                    Submit
                  </v-flex>
                
                </v-layout>
              </v-card>
            </v-expansion-panel-header>
          </v-expansion-panel>
        </v-expansion-panels> -->
        
        <!-- expansion panel songs -->
        <v-expansion-panels style="max-width:900px;margin-left:auto;margin-right:auto"  >
          <v-expansion-panel class="epHeader linkHoverSmall my-1" v-for="(song,index) in sortedSongs.slice(0,songsShown)" :key="index"> 
          
  
            <v-expansion-panel-header style="background-color:transparent;"  >
                <v-card color="transparent" flat>
                    <v-layout class="synThickFont" row wrap align-center>
                    
                      <!-- song icon -->
                      <v-flex xs1 md1>
                          <v-img :src="'/song_icons/'+song.icon" max-width="50px"></v-img>
                      </v-flex>
                      
                      <!-- song title -->
                      <v-flex fill-height xs4 md4 >
                          <v-btn text color="blue" class="mySongsTitlesInfo linkHover goToSongBtn" @click.native.stop  :to="{ name: 'Song', params: { songId: song.song_id }}">{{song.title}}</v-btn>
                      </v-flex>
                      
                      <!-- song genre -->
                      <v-flex xs2 md2 >
                          <div class="mySongsTitlesInfo" style="color:white !important;">{{song.genre}}</div>
                      </v-flex>
                      
                      <!-- submission count -->
                      <v-flex xs2 md2 class="text-center">
                          <div v-if="filterSubmissions(song.song_id).length ==0" class="mySongsTitlesInfo" style="color:grey !important;">0 Submissions</div>
                          <div v-else class="mySongsTitlesInfo" style="color:white !important;">{{filterSubmissions(song.song_id).length}} Submissions</div>
                      </v-flex>
                      
                      <!-- submit song button -->
                      <v-flex xs1 md1 class="pr-5">             
                          <v-btn class="mySongsTitlesInfo linkHover" text color='syn_green' @click.native.stop :to="{ name: 'SubmitSong_ChooseArtist', params: { songId: song.song_id}}">
                              <span>Submit</span>
                          </v-btn>
                      </v-flex>
                      
                      <!-- edit song button -->
                      <v-flex xs2 md2 class='text-center pl-5'>
                          
                          <EditSong v-if="filterSubmissions(song.song_id).length == 0"
                          :current_user_id="user.user_id" 
                          :current_song="{
                              index:index,
                              title:song.title,
                              genre:song.genre,
                              soundcloud:song.soundcloud,
                              comments:song.comments,
                              song_id:song.song_id
                              }"
                          @editSuccess="forceRerender"
                          /> 
                          
                          <v-tooltip v-else bottom>
                              <template v-slot:activator="{ on, attrs }">

                                  <div v-bind="attrs" v-on="on">
                                      <v-btn class="btnNoPadding"  @click.native.stop disabled text >
                                          <v-icon style="color:grey !important" >mdi-pencil</v-icon>
                                      </v-btn>
                                  </div>
                                  
                              </template>
                              <span class="synThinFont">You cannot edit an upload after submitting it for a feedback report.</span>
                          </v-tooltip>
                          
                          
                      </v-flex>
                      
                      <!-- delete song button -->
                      <!-- <v-flex xs1 class='text-center'> -->
                          <!-- <DeleteSong v-if="filterSubmissions(song.song_id).length == 0"
                          :current_song_id="song.song_id"
                          :current_song_audioPath="song.audioPath" 
                          @deleteSuccess="forceRerender"
                          /> 
                          <v-tooltip v-else bottom>
                              <template v-slot:activator="{ on, attrs }">

                                  <div v-bind="attrs" v-on="on">
                                      <v-btn class="btnNoPadding" @click.native.stop disabled text >
                                          <v-icon style="color:grey !important">mdi-delete</v-icon>
                                      </v-btn>
                                  </div>
                                  
                              </template>
                              <span class="synThinFont">You cannot delete a song after submitting it for a feedback report.</span>
                          </v-tooltip> -->
                          
                      <!-- </v-flex> -->
                      
                    </v-layout>
                </v-card>
            </v-expansion-panel-header>
          
            <!-- DIVIDER -->
            <!-- <v-divider class="v-divider-color"></v-divider> -->
            
            <!-- SUBMISSIONS -->
            <v-expansion-panel-content  >
              <v-divider class="v-divider-color-main"></v-divider>

              <v-list style="background-color:transparent" v-if="filterSubmissions(song.song_id).length > 0">
                

                <v-list style="background-color:transparent">
                  <v-list-item>
                    <v-layout row wrap align-center class="synThickFont">
                      <v-flex xs1>
                        
                      </v-flex>
                      <v-flex xs4>
                        <div class="grey--text">Artist</div>
                      </v-flex>
                      <v-flex xs2>
                        <div class="grey--text">Status</div>
                      </v-flex>
                      <v-flex xs2>
                        <div class="grey--text">Expires in</div>
                      </v-flex>
                      <v-flex xs3>
                        <!-- <div class="grey--text">Submission</div> -->


                      </v-flex>

                      <v-flex xs12 class="py-4">
                        <v-divider class="v-divider-color-sec"></v-divider>
                      </v-flex>
                      
                      
                    </v-layout>
                  </v-list-item>
                  <v-list-item  v-for="submission in filterSubmissions(song.song_id)" :key="submission.submission_id">
                    
                    <v-layout row wrap align-center class="synThinFont white--text">
                      <v-flex xs1>
                        <v-img :src="submission.artist_avatar" style="border-radius: 50% !important" width="50px"></v-img>
                      </v-flex>
                      <v-flex xs4>
                        <v-list-item-title class="linkHoverSmall"><router-link class="rl-no-dec  synThickFont syn_blue_button--text" :to="{ name: 'Artist', params: { artistId: submission.artist_id }}">{{submission.artist_name}}</router-link></v-list-item-title>
                      </v-flex>
                      <v-flex xs2>
                        <v-chip v-if="submission.returned" :class="` chip-returned-${submission.returned}`">Returned</v-chip>
                        <div v-else-if="submission.status='open'">
                          <v-chip v-if="expiryHours(submission.timestamp) == 'OVERDUE'" :class="`chip-expired`">Expired</v-chip>
                          <v-chip v-else :class="` chip-returned-${submission.returned}`">Open</v-chip>
                        </div>
                        
                      </v-flex>
                      
                      <v-flex xs2>
                        <div v-if="expiryHours(submission.timestamp)=='OVERDUE'" >N/A</div>
                        <div v-else >{{expiryHours(submission.timestamp)}}</div>
                      </v-flex>
                      <v-flex xs3>
                        <v-btn v-if="submission.status=='completed'" text color="syn_green" @click.prevent :to="{ name: 'FeedbackReport', params: { submissionId: submission.submission_id }}">View Feedback</v-btn>
                        <v-btn v-else-if="submission.status=='open'" text color="syn_blue_button" @click.prevent :to="{ name: 'Submission', params: { submissionId: submission.submission_id }}">View Submission</v-btn>
                      </v-flex>
                      <v-flex xs12 class="py-4">
                        <!-- <v-divider class="v-divider-color-sec"></v-divider> -->
                      </v-flex>
                      
                      
                    </v-layout>
                    
                    
                  </v-list-item>
                
                  
                </v-list>
                  





              </v-list>
              
              <v-list style="background-color:transparent" v-else class="text-center white--text">
                No Submissions
              </v-list>

              
              <v-btn class="linkHover" text color="primary" width="100%" :to="{ name: 'Song', params: { songId: song.song_id }}">More</v-btn>
            </v-expansion-panel-content>

          </v-expansion-panel>
        </v-expansion-panels>
        <div class="text-center mt-5">
          <v-btn text color="primary" class="linkHover" v-if="sortedSongs.length > 4 && songsShown < sortedSongs.length" @click="loadMore">load more</v-btn>
        </div>
    </div>
</template>
<script>
import EditSong from '@/components/songs/songComponents/popups/EditSong'
// import DeleteSong from '@/components/songs/songComponents/popups/DeleteSong'
// import AudioPlayer from '@/components/layout/audio-player.vue'
import moment from 'moment'
export default {
    name: "SongsEPDetailedMedium",
    components:{
        EditSong,
        // DeleteSong,
        // AudioPlayer
    },
    props: {
        sortedSongs: Array,
        submissions: Array,
        user: Object
    },
    data() {
        return {
          songsShown: 4,
          audioSources: [],
          childPlayButton: false,
        }
    },
    methods:{
        loadMore(){
          this.songsShown += 4
        },
        forceRerender() {
            this.$router.go()
        },
        updateParent(play){
            if (play){ // SONG IS PLAYING
                // console.log('event told us its playing');
                // this.extPlayButton = true
                this.childPlayButton = true
                // this.extPlayButton = null
                // this.reactToPlayChange = false

            } else if(!play) { //SONG IS PUT ON PAUSE
                // console.log('event told us its not playing');
                // this.extPlayButton = false
                this.childPlayButton = false
                // this.extPlayButton = null
            }
        },
        filterSubmissions(song_id){
            let filteredSubmissions = this.submissions.filter(function(event){
                return event.song_id == song_id
            })
            return filteredSubmissions
        },
        expiryHours(timestamp){
            var now = moment(Date.now()); //current time
            var end = moment(timestamp+259200000); // due date
            var duration = moment.duration(end.diff(now));
            var hours = duration.asHours();
            var floorHours = Math.floor(hours)
            var output
            if (floorHours > 1) {
                output = floorHours + " hours"
            } else if (floorHours == 1){
                output = floorHours + " hour"
            } else {
                output = "OVERDUE"
            }

            return output
        },
    },

}
</script>
<style>
.mySongsTitles{
  font-size:0.8em !important;
}
.mySongsTitlesInfo{
  font-size:0.9em !important;
  
}
.goToSongBtn{
  min-width: 0 !important;
  padding-left: 5px !important;
  padding-right: 5px !important;
  margin-left: -15px;
  
}
.btnNoPadding{
    min-width: 0 !important;
    padding-left: 5px !important;
    padding-right: 5px !important;
  /* margin-left: -15px; */
}
/* .songsAudioPlayer{
  background-color: #05192B !important;
} */
.epHeader{
    border:rgba(255,255,255,0.3) 1px solid !important;
    background-color:rgba(5,25,43,0.2) !important; 
    border-radius:5px !important 
  /* background-color:transparent !important; */
}

.epHeader .mdi-chevron-down{
  color:#087FFF !important;
}


</style>